import React from 'react';
import Form from 'react-bootstrap/Form';

export const Search = (props) => {
    return (
        <div className="input-group p-3">
            <div className="col-md-3">
                {(!props.fastVersion || props.fastVersion === "1")
                    ?
                    <Form.Select 
                        variant="primary" 
                        aria-label="Program Selection" 
                        className="col-md-3"
                        onChange={props.onSchoolChanged}>
                        <option value="ALL">All Schools</option>
                        <option value="AT">AT - Applied Technology</option>
                        <option value="BIT">BIT - Business Information Technology</option>
                        <option value="CHSS">CHSS - Communication, Humanities &amp; Social Sciences</option>
                        <option value="ED">ED - Education</option>
                        <option value="HWPS">HWPS - Health, Welness &amp; Public Safety</option>
                        <option value="MSE">MSE - Math, Science &amp; Engineering</option>
                        <option value="NPS">NPS - Nursing and Patient Support</option>
                        <option value="SAGE">SAGE - School of Adult &amp; General Education</option>
                    </Form.Select>
                    :
                    <Form.Select 
                        variant="primary" 
                        aria-label="Program Selection" 
                        className="col-md-3"
                        onChange={props.onSchoolChanged}>
                        <option value="ALL">All Schools</option>
                        <option value="BHT">BHT - Business, Hospitality, &amp; Technology</option>
                        <option value="ED">ED - Education</option>
                        <option value="HWPS">HWPS - Health, Wellness &amp; Public Safety</option>
                        <option value="LA">LA - Liberal Arts</option>
                        <option value="MSE">MSE - Math, Science &amp; Engineering</option>
                        <option value="NPS">NPS - Nursing and Patient Support</option>
                        <option value="STA">STA - Skilled Trades &amp; Arts</option>
                    </Form.Select>
                }
            </div>
            &nbsp;
            <input 
                type="text"
                className="form-control"
                name={props.name}
                placeholder="Filter Programs"
                onChange={props.onFilterChanged}
                />
        </div>
    );
}
